import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { saasApi } from "../api/saasApi";
import { validateRegistrationForm } from "../utils/validation";
import { persistAdminSession } from "../utils/session";
import "../styles/saas.css";

export default function RegisterPage() {
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState("form");
  const [form, setForm] = useState({
    plan_slug: searchParams.get("plan") || "starter",
    company_name: "",
    email: "",
    mobile: "",
    password: "",
    owner_name: "",
    gst_number: "",
    address: "",
    industry: "",
  });
  const [verify, setVerify] = useState({ otp: "" });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submitRegister = async (e) => {
    e.preventDefault();
    const v = validateRegistrationForm(form);
    setErrors(v);
    if (Object.keys(v).length) return;
    setLoading(true);
    try {
      const res = await saasApi.register(form);
      setMessage(res.message || "Check your email for the verification code.");
      setStep("verify");
    } catch (err) {
      setMessage(err.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const submitVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = searchParams.get("token");
      const res = await saasApi.verifyEmail({ token: token || undefined, otp: verify.otp });
      persistAdminSession(res.data);
      window.location.href = "/dashboard";
    } catch (err) {
      setMessage(err.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="saas-page saas-auth">
      <Link to="/">← Back</Link>
      <h1>{step === "form" ? "Start your free trial" : "Verify your email"}</h1>
      {message && <p className="saas-message">{message}</p>}

      {step === "form" ? (
        <form onSubmit={submitRegister} className="saas-form">
          <label>Company name *<input name="company_name" value={form.company_name} onChange={onChange} />{errors.company_name && <span className="saas-error">{errors.company_name}</span>}</label>
          <label>Email *<input name="email" type="email" value={form.email} onChange={onChange} />{errors.email && <span className="saas-error">{errors.email}</span>}</label>
          <label>Mobile *<input name="mobile" value={form.mobile} onChange={onChange} />{errors.mobile && <span className="saas-error">{errors.mobile}</span>}</label>
          <label>Password *<input name="password" type="password" value={form.password} onChange={onChange} />{errors.password && <span className="saas-error">{errors.password}</span>}</label>
          <label>Owner name<input name="owner_name" value={form.owner_name} onChange={onChange} /></label>
          <label>GST number<input name="gst_number" value={form.gst_number} onChange={onChange} /></label>
          <label>Address<textarea name="address" value={form.address} onChange={onChange} /></label>
          <label>Industry<input name="industry" value={form.industry} onChange={onChange} /></label>
          <button type="submit" className="saas-btn saas-btn--primary" disabled={loading}>{loading ? "Sending…" : "Continue"}</button>
        </form>
      ) : (
        <form onSubmit={submitVerify} className="saas-form">
          <label>Verification code<input value={verify.otp} onChange={(e) => setVerify({ otp: e.target.value })} placeholder="6-digit code from email" /></label>
          <button type="submit" className="saas-btn saas-btn--primary" disabled={loading}>{loading ? "Verifying…" : "Create workspace"}</button>
        </form>
      )}
      <p>Already have an account? <Link to="/login">Log in</Link></p>
    </div>
  );
}
